<div class="row">
  <form #contactForm="ngForm" (ngSubmit)="onSubmit()">
    <div class="col-sm-6">
      <mat-form-field class="input-control">
        <p class="input-label" [class.error]="nameInput.value!=='' && nameInput.dirty && nameInput.errors"
           [class.filledInput]="nameInput.dirty && !nameInput.errors">Full Name*</p>

        <input matInput type="text" pattern="[a-zA-Z ]+" #nameInput="ngModel" [(ngModel)]="name" name="name"
               maxlength="100" [errorStateMatcher]="enquireNowMatcher" required>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="input-control">
        <p class="input-label" [class.error]="emailInput.value!=='' && emailInput.dirty && emailInput.errors"
           [class.filledInput]="emailInput.dirty && !emailInput.errors">Email ID*</p>

        <input matInput type="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" #emailInput="ngModel"
               [(ngModel)]="email" name="email" [errorStateMatcher]="enquireNowMatcher" maxlength="60" required>
      </mat-form-field>
    </div>

    <div class="col-sm-6 pt-10">
        <span class="input-label phone-input"
              [class.error]="phoneNumberInput.value!=='' && phoneNumberInput.dirty && phoneNumberInput.errors"
              [class.filledInput]="phoneNumberInput.dirty && !phoneNumberInput.errors">Mobile Number*</span>
      <mat-form-field class="input-control">
        <p matPrefix class="phone-prefix"
           [class.error]="phoneNumberInput.value!=='' && phoneNumberInput.dirty && phoneNumberInput.errors">
          +91</p>
        <input matInput type="text" pattern="[0-9]+" #phoneNumberInput="ngModel" [(ngModel)]="phoneNumber"
               name="phoneNumber" [errorStateMatcher]="enquireNowMatcher"
               maxlength="10" minlength="10" required>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="input-control">
        <p class="input-label"
           [class.error]="loanAmountInput.value!=='' && loanAmountInput.dirty && loanAmountInput.errors"
           [class.filledInput]="loanAmountInput.dirty && !loanAmountInput.errors">Loan amount (≥ &#8377;50,000)*</p>

        <input matInput type="number" #loanAmountInput="ngModel" pattern="[0-9]{1,10}"
               [(ngModel)]="loanAmount" name="loanAmount" [errorStateMatcher]="enquireNowMatcher" required>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="input-control">
        <p class="input-label"
           [class.error]="empTypeInput.value!=='' && empTypeInput.dirty && empTypeInput.errors"
           [class.filledInput]="(empTypeInput.dirty && !empTypeInput.errors)">
          Employee Type*</p>
        <mat-select #empTypeInput="ngModel" [errorStateMatcher]="enquireNowMatcher" [(value)]="employeeType"
                    [(ngModel)]="employeeType" name="employeeType" (valueChange)="changeSalaryInput()"
                    [class.filledInput]="!(empTypeInput.dirty && !empTypeInput.errors)"
                    required>
          <mat-option *ngFor="let type of empTypes" [value]="type.value" required>
            {{ type.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="input-control">
        <p class="input-label" [ngStyle]="employeeType === undefined || employeeType === '' ? {color: 'grey'}: {color: 'black'}"
           [class.error]="annualSalaryInput.value!=='' && annualSalaryInput.dirty && annualSalaryInput.errors"
           [class.filledInput]="(annualSalaryInput.dirty && !annualSalaryInput.errors)">
          {{employeeType === 'Salaried' ? 'Monthly take home salary/Income': 'Annual salary/Income'}}*</p>
        <mat-select #annualSalaryInput="ngModel" [errorStateMatcher]="enquireNowMatcher"
                    [(ngModel)]="salary" name="salary" [disabled]="employeeType === undefined || employeeType === ''"
                    [class.filledInput]="!(annualSalaryInput.dirty && !annualSalaryInput.errors)"
                    required>
          <mat-option *ngFor="let s of salaryRange" [value]="s.value" required>
            {{ s.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="input-control">
        <p class="input-label"
           [class.error]="convenientTimeInput.value!=='' && convenientTimeInput.dirty && convenientTimeInput.errors"
           [class.filledInput]="(convenientTimeInput.dirty && !convenientTimeInput.errors)">
          Convenient time to reach out to you*</p>
        <mat-select #convenientTimeInput="ngModel" [errorStateMatcher]="enquireNowMatcher"
                    [(ngModel)]="convenientTime" name="convenientTime"
                    [class.filledInput]="!(convenientTimeInput.dirty && !convenientTimeInput.errors)"
                    required>
          <mat-option
                  value="10am - 8pm">Between 10 am to 8 pm
          </mat-option>
          <mat-option
                  value="10am - 1pm">Between 10 am to 1 pm
          </mat-option>
          <mat-option
                  value="1pm - 5pm">Between 1 pm to 5 pm
          </mat-option>
          <mat-option
                  value="5pm - 8pm">Between 5 pm to 8 pm
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="input-control">
        <p class="input-label" [class.error]="!cityInput.value && cityInput.dirty && cityInput.errors"
           [class.filledInput]="(cityInput.dirty && !cityInput.errors)">
          City* (finzy offers loans only in the below mentioned cities)</p>
        <mat-select #cityInput="ngModel" [errorStateMatcher]="enquireNowMatcher" [(ngModel)]="selectedCity" name="city"
                    [class.filledInput]="!(cityInput.dirty && !cityInput.errors)" required>
          <mat-option *ngFor="let availableCity of cities" [value]="availableCity">
            {{ availableCity }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-sm-12 submissionMessage">
      <p [class.error]="!submissionResult" [class.success]="submissionResult">{{submissionMessage}}</p>
    </div>

    <div class="col-sm-12">
      <div class="row info-and-action-block">
        <div class="col-xs-6 pull-left">
          <p class="call-us-enquire-section text-color-grey text-uppercase text-center">Or Call us : <span
            class="text-color-finzy-blue display-inline-block">9341 300 300</span></p>
        </div>

        <div class="col-xs-6 pull-right">
          <button mat-flat-button type="submit" [disabled]="contactForm.invalid" id="submit"
                  class="col-sm-12 primary pt-1">
            SUBMIT
          </button>
        </div>
      </div>
    </div>

  </form>
</div>
